<template>
  <div style="height: 100%;">
    <div style="width: 393px">
      <div class="webhfive-addbox-box">
        <el-form size="medium" label-width="auto" ref="form" :model="form">
          <el-form-item label="触发条件：" prop="mode">
            <el-select v-model="form.mode" placeholder="请选择">
              <el-option v-for="(mode, key) in triggerMode" :key="key" :label="mode" :value="key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="条件对象：" prop="target">
            <el-select v-model="form.target" placeholder="请选择">
              <el-option v-for="(mode, key) in triggerTarget" :key="key" :label="mode" :value="key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间阈值：" prop="timeThreshold" v-if="form.mode==='silence'">
            <el-row type="flex" class="form-item-complex" style="width:80%;">
              <el-input-number v-model="form.timeThreshold" controls-position="right" :min="0" :step="5" step-strictly></el-input-number>
              <el-button>秒</el-button>
            </el-row>
          </el-form-item>
          <el-form-item label="关键字规则：" prop="keyRule" v-if="form.mode==='keyword'">
            <el-input type="textarea" v-model="form.keyRule" :rows="4" placeholder="可设置多个，多个触发词用英文竖线隔开。"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-row type="flex" justify="center" style="padding-top:20px;">
        <el-button size="medium" @click="cancel()">取消</el-button>
        <el-button size="medium" type="primary" @click="submit()">确定</el-button>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      form: {
        mode: 'silence',
        modeName: '静默',
        target: 'agent',
        targetName: '坐席',
        timeThreshold: 0,
        keyRule: ''
      },
      triggerMode: { silence: '静默', keyword: '关键字' },
      triggerTarget: { agent: '坐席', user: '访客' }
    }
  },
  props: {
    currTriggerSet: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    }
  },
  mounted() {
    if (this.currTriggerSet && this.currTriggerSet.mode) {
      // 说明是编辑数据
      this.form = { ...this.currTriggerSet }
    }
  },
  computed: {
  },
  methods: {
    cancel() {
      this.form.mode = ''
      this.form.target = ''
      this.form.timeThreshold = 0
      this.form.keyRule = ''
      this.$emit('closeAutoTrigger', null)
    },
    submit() {
      if (this.form.mode === 'silence' && !this.form.timeThreshold) {
        this.$message.warning('静默触发时时间阈值不能为0')
        return false
      }
      if (this.form.mode === 'keyword' && this.form.keyRule.trim().length === 0) {
        this.$message.warning('关键字触发时关键字规则不能为空')
        return false
      }
      this.form.modeName = this.triggerMode[this.form.mode]
      this.form.targetName = this.triggerTarget[this.form.target]
      this.$emit('closeAutoTrigger', this.form)
    }
  }
}
</script>
<style scoped lang="scss">
.content {
  margin: 0;
  padding: 0;
}
.el-input {
  width: 100%;
}
.search-form.el-form {
  display: flex;
  justify-content: flex-start;
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }
}
.selectInput {
  line-height: inherit;
}
.el-form-item {
  position: relative;
  ::v-deep .el-form-item__label {
    height: 40px;
    line-height: 40px !important;
  }
  .input-border {
    ::v-deep .el-input__inner {
      padding-left: 5px;
      padding-top: 5px;
      padding-bottom: 5px;
      border-radius: 5px;
      border-bottom: 1px solid #dcdfe6;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: break-word;
      word-break: break-all;
      &:focus {
        border-bottom: 1px solid #409eff;
      }
    }
  }
  .icon-delete {
    color: #f66f6a;
  }
}

.table-page {
  // margin: 20px 0;
}

.el-dialog .el-dialog__body .el-button + .el-button {
  margin-left: 10px;
}

.el-form .el-form-item[data-v-3da85692] .el-form-item__content .el-row {
  width: 100%;
}
</style>
<style lang="scss">
.el-textarea__inner {
  resize: none !important;
}
.el-pagination.is-background .el-pagination__editor.el-input {
  width: 30px !important;
}
</style>
